
<template>
  <div class="flex flex-col text-white space-y-2 " dir="rtl">
   
    <input
      :id="id"
      :value="modelValue"
      type="tel"
      :placeholder="placeholder"
      :disabled="disabled"
      class="border rounded px-2 py-2 focus:outline-none text-black focus:border-basic w-full"
      :class="(touched && !isValid) ? 'border-red-500 border-2' : 'border-green-500 border-2'"
      @input="handleInput"
      @blur="handleBlur"
    />

   
  </div>
</template>

<script>
export default {
  name: "SudanPhoneInput",

  props: {
    modelValue: {
      type: String,
      default: "",
    },

  

    placeholder: {
      type: String,
      default: "09XXXXXXXX",
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    id: {
      type: String,
      default: "sudan-phone",
    },
  },

  emits: [
    "update:modelValue",
    "valid",
  ],

  data() {
    return {
      touched: false,
      isValid: false,
      errorMessage: "",
    };
  },

  methods: {
      normalizePhone(value) {
        // Remove spaces, +, -, brackets, etc.
        let phone = String(value).replace(/\D/g, "");

        // 002499xxxxxxxx -> 2499xxxxxxxx
        if (phone.startsWith("00249")) {
          phone = phone.substring(2);
        }

        // 09xxxxxxxx -> 2499xxxxxxxx
        else if (phone.startsWith("09")) {
          phone = `249${phone.substring(1)}`;
        }

        // 01xxxxxxxx -> 2491xxxxxxxx
        else if (phone.startsWith("01")) {
          phone = `249${phone.substring(1)}`;
        }

        // 9xxxxxxxx -> 2499xxxxxxxx
        else if (phone.startsWith("9")) {
          phone = `249${phone}`;
        }

        return phone;
      },

      validatePhone(value) {
        const phone = this.normalizePhone(value);


        const regex = /^249(?:1\d{8}|(?:90|91|92|93|94|95|96|99)\d{7})$/;

        if (!phone) {
          return {
            valid: false,
            phone: "",
            message: "رقم الهاتف مطلوب",
          };
        }

        if (!regex.test(phone)) {
          return {
            valid: false,
            phone,
            message: "رقم الهاتف السوداني غير صحيح",
          };
        }

        return {
          valid: true,
          phone,
          message: "رقم الهاتف صحيح",
        };
      },

      handleInput(event) {
        const value = event.target.value;

        // Keep exactly what the user typed in the input
        this.$emit("update:modelValue", value);

        // Validate
        const result = this.validatePhone(value);

        this.isValid = result.valid;
      this.errorMessage = result.message;

      this.$emit("valid", result);
    },

    handleBlur() {
      this.touched = true;

      const result = this.validatePhone(this.modelValue);

      this.isValid = result.valid;
      this.errorMessage = result.message;

      this.$emit("valid", result);
    },
  },
};
</script>
